import React from "react";
import CaseSummary from "../case-summary/case-summary";
import CustomTable from "../common/custom-table/custom-table";

import "./dashboard.scss";

const Dashboard = ({ apiState }) => {
  const { caseSummaryData, headers, rows } = apiState || {};

  return (
    <>
      {caseSummaryData && <CaseSummary apiState={apiState} />}
      {headers && rows && <CustomTable headers={headers} rows={rows} />}
    </>
  );
};

export default Dashboard;
